module.exports = __webpack_public_path__ + "static/media/ourbrands-logo2.fc849f7a.webp";